import { createApp } from 'vue';
import FreeChartAnalysis from '../../free/FreeChartAnalysis.vue'
const appElements = document.querySelectorAll('.vue-free-analysis')

Array.from(appElements).forEach(element => {
  createApp(FreeChartAnalysis).mount(element);
});